import React, { Fragment, Component } from 'react'
import ConnectionTable from 'components/ConnectionTable'
import Pagination from 'components/Pagination'
import styled from '@emotion/styled'
import { spacer, ButtonLink, Input, Button } from 'stylist'
import { isConnectionEnd } from 'utils/relay'
import debounce from 'lodash/debounce'

const TableToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacer(4)};
`

class PaginatedConnectionTable extends Component {
  state = {
    q: this.props.query.get('q') || ''
  }

  handleChange = e => this.setState({ q: e.target.value }, this.notifyChange)

  notifyChange = debounce(
    () => this.props.history.replace(`?q=${this.state.q}`),
    250
  )

  render() {
    const {
      connection,
      loadMoreEntries,
      query,
      showNew,
      showManage,
      manage,
      history,
      ...rest
    } = this.props
    const { q } = this.state
    const { match: { url } } = rest

    return (
      <Fragment>
        <TableToolbar role="toolbar">
          <div>
            <Input
              onChange={this.handleChange}
              value={q}
              placeholder="Search"
              inline
            />
            {showNew && (
              <ButtonLink marginLeft kind="standard" to={`${url}/new`}>
                New
              </ButtonLink>
            )}
            {showManage && (
              <ButtonLink marginLeft kind="standard" to={`${url}/manage`}>
                Add/Remove
              </ButtonLink>
            )}
            {manage && (
              <Button marginLeft kind="standard" onClick={history.goBack}>
                Back
              </Button>
            )}
          </div>
          <Pagination
            hasPreviousPage={!isConnectionEnd(connection, 'backward')}
            onPrevClick={() => loadMoreEntries('backward')}
            hasNextPage={!isConnectionEnd(connection, 'forward')}
            onNextClick={() => loadMoreEntries('forward')}
          />
        </TableToolbar>
        <ConnectionTable
          history={history}
          connection={connection}
          manage={manage}
          {...rest}
        />
      </Fragment>
    )
  }
}

export default PaginatedConnectionTable



// WEBPACK FOOTER //
// ./src/components/PaginatedConnectionTable/index.js